import { IconChevronUp } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { UnstyledButton } from '~/domains/design-system/Button';
import { Text } from '../../../Text';

import type { ChatWidgetProps } from './types';
import useChatWidget from './useChatWidget';
import useStyles from './ChatWidget.styles';

function ChatWidget({
  title = 'Contest Huddle',
  newPostCount = 0,
  unreadMessageCount = 0,
  onClose,
  isMinimized = false,
  ...props
}: ChatWidgetProps) {
  const { t } = useTranslation('chat');
  const { classes } = useStyles();
  const { handleClose } = useChatWidget({ onClose });

  const hasNotifications = newPostCount > 0 || unreadMessageCount > 0;

  return (
    <UnstyledButton className={classes.container} onClick={handleClose} {...props}>
      <div className={classes.content}>
        <div className={classes.header}>
          <Text variant="headline-large" className={classes.title}>
            {title}
          </Text>
          <div className={classes.expandButton} aria-hidden="true">
            <IconChevronUp size={24} color="white" />
          </div>
        </div>
        {hasNotifications && (
          <div className={classes.subtitle}>
            {newPostCount > 0 && (
              <div className={classes.notification}>
                <Text variant="body-medium" className={classes.notificationText}>
                  {t('widget.newPost__hasPlural', { count: newPostCount })}
                </Text>
                <div className={classes.pip} />
              </div>
            )}
            {unreadMessageCount > 0 && (
              <div className={classes.notification}>
                <Text variant="body-medium" className={classes.notificationText}>
                  {t('widget.unreadMessage__hasPlural', { count: unreadMessageCount })}
                </Text>
                <div className={classes.pip} />
              </div>
            )}
          </div>
        )}
      </div>
    </UnstyledButton>
  );
}

export default ChatWidget;
